var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Validation } from './Validation';
import { store as mainStore } from '../App';
import { T } from './i18n';
import { mapValues, objectValues } from './Utils';
import { marks, strMark } from '../Theme';
import { toParentPath } from './History';
export var handleSubmit = function (_a) {
    var _b;
    var propValues = _a.propValues, stateValues = _a.stateValues, schema = _a.schema;
    var fields = propValues.fields, propsValues = propValues.values, store = propValues.store, onSubmit = propValues.onSubmit;
    var values = __assign({}, stateValues);
    // console.log('handleSubmit - fields', fields)
    // console.log('handleSubmit - values', values)
    // console.log('handleSubmit - schema', schema)
    // console.log('handleSubmit - propsValues', propsValues)
    var validation = new Validation(values, schema);
    if (validation.valid) {
        // Remove unmodified value
        // console.log('antes de fields.map - values', values)
        fields.map(function (field) {
            if (propsValues && values[field.column ? field.column : field.name] === propsValues[field.column ? field.column : field.name]) {
                delete values[field.column ? field.column : field.name];
            }
        });
        if (Object.keys(values).length === 0)
            return mainStore.UI.newWarning(T('nothingModified'));
        // Convert empty strings to null
        // console.log('antes de mapValues - values', values)
        values = mapValues(values, function (value) { return (value === '' ? null : value); });
        // console.log('mapValues - values', values)
        // Use FormData instead of JSON if there is a image in value
        var data_1;
        if (Object.keys(schema).includes('image')) {
            // console.log('handleSubmit - image')
            data_1 = new FormData();
            Object.keys(values).forEach(function (key) {
                if (values[key]) {
                    if (values[key] instanceof FileList) {
                        for (var i = 0; i < values[key].length; i++) {
                            data_1.append(key, values[key][i]);
                        }
                    }
                    else {
                        data_1.append(key, values[key]);
                    }
                }
                else if (values[key] === null) {
                    data_1.append(key, '');
                }
            });
        }
        else {
            data_1 = values;
        }
        // console.log('handleSubmit - data', data)
        if (onSubmit)
            return onSubmit(data_1);
        if (store && data_1) {
            var request = void 0;
            if (propsValues) {
                request = store.update(propsValues.id, data_1);
                return request;
            }
            else {
                var _data = data_1;
                if (propValues.sendIfIsCivitrip === true) {
                    var isCivitrip = ((_b = propValues.queryParams) === null || _b === void 0 ? void 0 : _b[strMark]) === marks.civitrip;
                    if (isCivitrip) {
                        _data['isCivitrip'] = true;
                    }
                }
                request = store.create(_data);
                return request;
            }
            request.then(toParentPath);
        }
        else {
            mainStore.UI.newWarning('error indefinido');
        }
    }
    else {
        mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
        // console.log('handleSubmit - !validation.valid - validation.errors', validation.errors)
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/formHandleSubmit.ts
// module id = 1259
// module chunks = 0